// Map known Supabase / PostgREST error codes to user-friendly localised strings.
// Anything we don't recognise falls back to a generic message — never render
// raw error.message to a customer surface (it leaks Postgres constraint names,
// PostgREST internals, and isn't localised).
//
// The raw error is always console.error'd so Sentry still gets the original.

const MESSAGES = {
  en: {
    over_email_send_rate_limit: 'Too many requests. Please wait a minute and try again.',
    over_request_rate_limit:    'Too many requests. Please wait a moment and try again.',
    invalid_credentials:        'Incorrect email or password.',
    weak_password:              'Please choose a stronger password.',
    same_password:              'Please choose a different password.',
    user_already_exists:        'An account already exists for this email.',
    email_address_not_authorized:'We can’t send to that email address.',
    default:                    'Something went wrong. Please try again.',
  },
  bg: {
    over_email_send_rate_limit: 'Твърде много заявки. Моля, изчакайте минута и опитайте отново.',
    over_request_rate_limit:    'Твърде много заявки. Моля, изчакайте малко и опитайте отново.',
    invalid_credentials:        'Грешен имейл или парола.',
    weak_password:              'Моля, изберете по-силна парола.',
    same_password:              'Моля, изберете различна парола.',
    user_already_exists:        'Вече има акаунт с този имейл.',
    email_address_not_authorized:'Не можем да изпратим до този имейл.',
    default:                    'Нещо се обърка. Опитайте отново.',
  },
};

export function localiseError(error, lang = 'en') {
  if (!error) return '';
  console.error('[localiseError]', error);
  const map = MESSAGES[lang] || MESSAGES.en;
  const code = error.code || error.name || '';
  return map[code] || map.default;
}
